import PromoService from "../services/promo.service";

const state = {
	discount: null,
	promoType: null,
	departments: null,
	promoId: null,
	totalForBarcode: 0,
	itemsForBarcode: [],
	currentItems: [],
	promos: [],
	promotionId: null,
	oneTimeDiscountDoc: null,
	buyXgetYPromotionId: null,
	total: 0,
	columns: [
		{
			key: 'id',
			label: '№',
			sortable: true,
			visible: true,
			changebale: false
		},
		{
			key: 'changed',
			label: 'promo-to-product.changed',
			'class': 'td-20',
			sortable: true,
			visible: false,
			changebale: true
		},
		{
			key: 'comment',
			label: 'promo-to-product.comment',
			'class': 'td-20',
			sortable: true,
			visible: true,
			changebale: true
		},
		{
			key: 'create',
			label: 'promo-to-product.created',
			'class': 'td-20',
			sortable: true,
			visible: false,
			changebale: true
		},
		{
			key: 'version',
			label: 'promo-to-product.version',
			'class': 'td-20',
			sortable: true,
			visible: false,
			changebale: true
		},
		{
			key: 'discount',
			label: 'promo-to-product.discount',
			'class': 'td-20',
			sortable: true,
			visible: true,
			changebale: true
		},
		{
			key: 'start',
			label: 'promo-to-product.start-date',
			'class': 'td-20',
			sortable: true,
			visible: true,
			changebale: true,
		},

		{
			key: 'finish',
			label: 'promo-to-product.finish-date',
			'class': 'td-20',
			sortable: true,
			visible: true,
			changebale: true
		},
		{
			key: 'departments',
			label: 'promo-to-product.department',
			'class': 'td-26',
			sortable: false,
			visible: true,
			changebale: true
		},

		{
			key: 'status',
			label: 'promo-to-product.status',
			sortable: true,
			visible: true,
			changebale: true
		},
		{
			key: 'actions',
			label: 'goods.actions',
			'class': 'table_actions',
			visible: true,
			changebale: false
		}

	],

	searchDoubleDiscount: []
};


const getters = {
	columns: (state) => {
		return state.columns
	},
	getPromos: (state) => {
		return state.promos
	},
	getDeps: (state) => {
		return state.departments
	}

};


const actions = {
	/**
	 * Fetch action
	 * @returns {Promise<boolean>}
	 */
	async fetchPromos({commit}) {
		try {
			PromoService.getAllPromos().then(response => {
				commit('setPromos', response.data);
			});

		} catch (e) {
			//let response = JSON.parse(e.request.response);
			//commit('fetchGoodError', {message: response.message, boolean: true});
			throw e
		}
	},

	async setCurrentItems({commit},payload){
			await commit('setDataCurrentItems',payload)
	},

	async fetchDepartment({commit}) {
		try {
			const response = await PromoService.getDepartments();
			commit('setDepartment', response.data);
		} catch (e) {
			//let response = JSON.parse(e.request.response);
			//commit('fetchGoodError', {message: response.message, boolean: true});
			throw e
		}
	},
	async searchDoubleDiscountStore({commit}, data) {
		const response = await PromoService.searchDoubleDiscount(data);
		commit('setDoubleDiscount', response.data);
	}
};

const mutations = {
	setDepartmentsForBarcode(state, payload) {
		state.discount = payload.discount
		state.promoType = payload.promoType
		state.departments = payload.departments
		state.promoId = payload.id
	},
	setItemsForBarcode(state, payload) {
		state.itemsForBarcode = payload
		if(state.itemsForBarcode) {
			state.itemsForBarcode.forEach(el => {
				el.count = 1
			})
		}
	},
	setTotalForBarcode(state, payload) {
		state.totalForBarcode = payload
	},
	setDataCurrentItems(state, payload) {
		state.currentItems = payload
	},
	setPromotion(state, promotion) {
		state.promotionId = promotion.promotionId;
	},
	setOneTimeDiscountDoc(state, oneTimeDiscountDoc){
		state.oneTimeDiscountDoc = oneTimeDiscountDoc;
	},
	setSecondPromotion(state, promotion) {
		state.buyXgetYPromotionId = promotion.promotionId;
	},
	setDoubleDiscount(state, response) {
		state.searchDoubleDiscount = response;
	},
	setPromos(state, data) {
		state.promos = data.items;
		state.total = data.total;
	},
	setDepartment(state, data) {// Allohu akbar
		state.departments = data
	}
};

export const promo = {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
};
